import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoanNRecoveriesRegisterFromCComponent } from './loan-n-recoveries-register-from-c.component';

const routes: Routes = [
  { path: "", redirectTo: "loan-n-recoveries-register-from-C", pathMatch: "full" },
  { path: "loan-n-recoveries-register-from-C", component: LoanNRecoveriesRegisterFromCComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoanNRecoveriesRegisterFromCRoutingModule { }
